<template>
  <div class="row">
    <div style="position: fixed; top: 10px; z-index: 9000; right: 95px">
      <Filtro :filtro="false" @exportar="exportar">
      </Filtro>
    </div>
    <div class="col-6" v-for="(k, i) in getKpis()" :key="i">
      <div class="card card-modern" style="border: none; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
        <div class="modern-header" style="margin-bottom: 15px; border-bottom: 1px solid #e2e8f0; padding-bottom: 10px;">
          <h4 class="card-title" style="margin: 0; font-size: 1.25rem; color: #1e293b; font-weight: 600;">{{ k.nome }}</h4>
        </div>
        <div class="card-body table-responsive">
          <table class="table table-modern">
            <thead>
              <tr>
                <th>Peso (%)</th>
                <th>Intervalo Início</th>
                <th>Intervalo Fim</th>
                <th># de municípios</th>
                <th>% de municípios</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(f, fi) in k.faixas" :key="fi">
                <td>{{ (f.percentual * 100).toFixed(0) }}%</td>
                <td>{{ (f.inicio + "").replace(".", ",") }}</td>
                <td>{{ (f.fim + "").replace(".", ",") }}</td>
                <td>{{ f.quantidade }}</td>
                <td>{{ (f.indice * 100).toFixed(2).replace(".", ",") }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Filtro from "../Filtro.vue";
export default {
  props: ["kpiinit"],
  data() {
    return {
      kpi: this.kpiinit,
    };
  },
  components: {
    Filtro,
  },
  methods: {
    exportar() {
      var json = [];
      var head = {
        1: "Peso (%)",
        2: "Intervalo Início",
        3: "Intervalo Fim",
        4: "# de municípios",
        5: "% de municípios",
      };
      for (const d of this.getKpis()) {
        json.push({ 1: d.nome, 2: " ", 3: "  ", 4: "   ", 5: "    " });
        json.push(head);
        for (const f of d.faixas) {
          json.push({
            1: (f.percentual * 100).toFixed(0) + "%",
            2: (f.inicio + "").replace(".", ","),
            3: (f.fim + "").replace(".", ","),
            4: f.quantidade,
            5: (f.indice * 100).toFixed(2).replace(".", ",") + "%",
          });
        }
        json.push({1: '', 2: "", 3: "", 4: "", 5: ""});
      }
      PLANILHA.export("Classe", "xlsx", json);
    },
    getKpis() {
      var kpis = [];
      for (const key in this.kpi) {
        var pvf = this.kpi[key];
        for (const k1 in pvf.fcss) {
          var fcs = pvf.fcss[k1];
          for (const k2 in fcs.kpis) {
            var kpi = fcs.kpis[k2];
            kpis.push(kpi);
          }
        }
      }
      return kpis;
    },
  },
};
</script>